import { render, staticRenderFns } from "./productAppointmentSuccess.vue?vue&type=template&id=c1a51032&scoped=true"
import script from "./productAppointmentSuccess.vue?vue&type=script&lang=js"
export * from "./productAppointmentSuccess.vue?vue&type=script&lang=js"
import style0 from "./productAppointmentSuccess.vue?vue&type=style&index=0&id=c1a51032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a51032",
  null
  
)

export default component.exports